<!--
    校区管理-校区账单-统计
    功能：展示校区账单统计
    说明：旧版
-->
<template>
  <div class="statistical">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="直播课消费统计" name="school_teaching">
<!--        excelLabel="导出excel"-->
        <AppList
          v-if="activeName === 'school_teaching'"
          ref="list_live"
          :list.sync="list_live"
          title=""
          :columns="columnsLiveAll"
          :columnsCheck="columnsLive"
          api="/api/liveroom/all/bill"
          :api-type="`${api}/api/liveroom?is_show_teacher=1&equal[status]=3&order[id]=desc`"
          @checkedColumns="checkedColumns"
          @excelPage="excelExport">
          <AppSearch
            slot="search"
            :order="{ type: 'id', name: 'desc'}"
            :search-arr="searchArrLive"/>
          <template slot-scope="props">
            <el-table :data="props.listData">
              <el-table-column
                v-for="column in columnsLive"
                v-if="!column.show"
                :key="column.prop"
                :prop="column.prop"
                :label="column.label"
                :width="column.width"
                :formatter="column.formatter"
              />
              <el-table-column
                label="操作"
                width="80px"
                class="orgin-btn"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    @click="StatisticalClass(scope.row)"
                  >详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </AppList>
      </el-tab-pane>
<!--      <el-tab-pane label="录制统计" name="school_record">-->
<!--        <AppList-->
<!--          v-if="activeName === 'school_record'"-->
<!--          ref="list"-->
<!--          :list.sync="list"-->
<!--          title=""-->
<!--          api="/department">-->
<!--          <AppSearch-->
<!--            slot="search"-->
<!--            :order="{ type: 'id', name: 'desc'}"-->
<!--            :search-arr="searchArr"/>-->
<!--          <template slot-scope="props">-->
<!--            <el-table :data="props.listData">-->
<!--              <el-table-column-->
<!--                v-for="column in columns"-->
<!--                v-if="!column.show"-->
<!--                :key="column.prop"-->
<!--                :prop="column.prop"-->
<!--                :label="column.label"-->
<!--                :width="column.width"-->
<!--                :formatter="column.formatter"-->
<!--              />-->
<!--            </el-table>-->
<!--          </template>-->
<!--        </AppList>-->
<!--      </el-tab-pane>-->
<!--      <el-tab-pane label="回放统计" name="school_replay">-->
<!--        <AppList-->
<!--          v-if="activeName === 'school_replay'"-->
<!--          ref="list"-->
<!--          :list.sync="list"-->
<!--          title=""-->
<!--          api="/department">-->
<!--          <AppSearch-->
<!--            slot="search"-->
<!--            :order="{ type: 'id', name: 'desc'}"-->
<!--            :search-arr="searchArr"/>-->
<!--          <template slot-scope="props">-->
<!--            <el-table :data="props.listData">-->
<!--              <el-table-column-->
<!--                v-for="column in columns"-->
<!--                v-if="!column.show"-->
<!--                :key="column.prop"-->
<!--                :prop="column.prop"-->
<!--                :label="column.label"-->
<!--                :width="column.width"-->
<!--                :formatter="column.formatter"-->
<!--              />-->
<!--            </el-table>-->
<!--          </template>-->
<!--        </AppList>-->
<!--      </el-tab-pane>-->
    </el-tabs>
  </div>
</template>

<script>
  import list from '@/mixins/list';
  import merge from 'webpack-merge';

  export default {
    name: "BillStatistical",
    mixins: [list],
    data() {
      return {
        id: this.$route.params.id || undefined,
        code: this.$route.params.code || undefined,
        activeName: 'school_teaching',
        list: {},
        list_live: {},
        columnsLiveAll: [
          {
            label: '直播时间',
            disabled: true,
            width: '180px',
            formatter: row => {
              let time = '';
              switch (row.status) {
                case 1: // 未开始 展示预设直播开始时间~--
                  time = `${row.start_time} ~ --`;
                  break;
                case 2: // 直播中 展示实际直播开始时间~--
                  time = `${row.begin_time} ~ --`;
                  break;
                case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
                  time = `${row.begin_time} ~ ${row.close_time}`;
                  break;
                case 4: // 缺课 预设时间~--
                  time = `${row.start_time} ~ --`;
                  break;
                case 5: // 已取消 预设时间~--
                  time = `${row.start_time} ~ --`;
                  break;
                default:
                  break;
              }
              return time
            }
          },
          {
            label: '直播时长',
            formatter: row => {
              const time = this.$setting.setTime(row.act_liveroom_second);
              return `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`
            }
          },
          {
            label: '直播消费金额',
            formatter: row => {
              return Number(row.bill_teaching_amount).toFixed(2)
            }
          },
          { prop: 'name', label: '课题', disabled: true },
          { prop: 'number', label: '教室编号' },
          { prop: 'teacher.name', label: '授课老师', disabled: true },
          { prop: 'teacher.mobile', label: '手机号' },
          {
            label: '直播类型',
            formatter: row => {
              const type = {
                1: '班级直播间',
                2: '链接直播间'
              };
              return type[row.type]
            }
          },
          // { prop: 'name6', label: '课件类型' }, // 缺少
          // { prop: 'name7', label: '课件名称' }, // 缺少
          {
            label: '直播状态',
            formatter: row => {
              const status = {
                1: '未开始',
                2: '直播中',
                3: '已结束',
                4: '缺课',
                5: '已取消'
              };
              return status[row.status]
            }
          },
          // { prop: 'video_type', label: '授课类型' }, // 缺少
          { prop: 'student_count', label: '学生数' },
          { prop: 'student_count', label: '上课总人次', disabled: true }
        ],
        columnsLive: [],
        columns: [],
        api: '', // api
      }
    },
    computed: {
      searchArrLive() {
        const column = [
          { prop: 'name', label: '课题名称' },
          { prop: 'teacher_name', label: '授课老师' },
          { prop: 'teacher_mobile', label: '手机号' },
          { prop: 'number', label: '教室编号' }
        ];
        return [
          {
            componentType: 'AppSearchDate',
            searchType: 'created_at',
          },
          {
            selectValue: [
              { value: 1, name: '班级直播' },
              { value: 2, name: '链接直播' }
            ],
            componentType: 'AppSearchStatus',
            searchType: 'type',
            placeholder: '请选择直播类型'
          },
          // {
          //   selectValue: [ // 缺少
          //     { value: 0, name: '互动课件' },
          //     { value: 1, name: '云盘文件' }
          //   ],
          //   componentType: 'AppSearchStatus',
          //   searchType: 'is_auth_minipro',
          //   placeholder: '请选择课件类型'
          // },
          // {
          //   selectValue: [
          //     { value: 1, name: '是' },
          //     { value: 0, name: '否' }
          //   ],
          //   componentType: 'AppSearchStatus',
          //   searchType: 'is_playback',
          //   placeholder: '请选择录制情况'
          // },
          // {
          //   selectValue: [ // 缺少
          //     { value: 0, name: '是' },
          //     { value: 1, name: '否' }
          //   ],
          //   componentType: 'AppSearchStatus',
          //   searchType: 'is_auth_minipro',
          //   placeholder: '请选择回放情况'
          // },
          { componentType: 'AppSearchColumn', searchType: column },
        ];
      },
      searchArr() {
        const column = [
          { prop: 'name', label: '课题名称' },
          { prop: 'phone', label: '授课老师' },
          { prop: 'phone', label: '手机号' },
          { prop: 'phone', label: '教室编号' }
        ];
        return [
          {
            componentType: 'AppSearchDate',
            searchType: 'created_at',
          },
          { componentType: 'AppSearchColumn', searchType: column },
        ];
      },
      role() {
        return this.$store.state.user;
      },
      school() {
        return this.$store.state.school
      }
    },
    created() {
      this.columnsLive = [
        {
          label: '直播时间',
          width: '180px',
          formatter: row => {
            let time = '';
            switch (row.status) {
              case 1: // 未开始 展示预设直播开始时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 2: // 直播中 展示实际直播开始时间~--
                time = `${row.begin_time} ~ --`;
                break;
              case 3: // 已结束 展示实际直播开始时间~实际直播下课时间
                time = `${row.begin_time} ~ ${row.close_time}`;
                break;
              case 4: // 缺课 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              case 5: // 已取消 预设时间~--
                time = `${row.start_time} ~ --`;
                break;
              default:
                break;
            }
            return time
          }
        },
        {
          label: '直播时长',
          formatter: row => {
            const time = this.$setting.setTime(row.act_liveroom_second);
            return `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`
          }
        },
        {
          label: '直播消费金额',
          formatter: row => {
            return Number(row.bill_teaching_amount).toFixed(2)
          }
        },
        { prop: 'name', label: '课题' },
        { prop: 'number', label: '教室编号' },
        { prop: 'teacher.name', label: '授课老师' },
        { prop: 'student_count', label: '上课总人次' }
      ];
      this.columns = [
        { prop: 'name1', label: '教室编号' },
        { prop: 'name2', label: '视频名称' },
        { prop: 'name3', label: '录制文件号' },
        { prop: 'name4', label: '资源存储大小' },
        { prop: 'name5', label: '时间' },
        { prop: 'name6', label: '录制时长' },
        { prop: 'name7', label: '录制人' }
      ];
      if (this.code) {
        this.activeName = this.code;
      }
      if (this.id) {
        this.school.forEach(item => {
          if (item.id === Number(this.id)) {
            this.api = `https://${item.domain}`
          }
        });
      } else {
        this.api = `https://${this.$store.state.choicesSchool.domain}`
      }
    },
    methods: {
      timeFamate (num) {
        return num > 9 ? num : '0' + num;
      },
      // 选择列表字段
      checkedColumns(val) {
        const data = [];
        val.forEach(item => {
          this.columnsLiveAll.forEach(v => {
            if (v.label === item) {
              data.push(v)
            }
          })
        });
        this.$nextTick(() =>{
          this.columnsLive = data;
        });
      },
      handleClick() {
        this.$router.replace({
          query: merge({ page: 1, per_page: 10, 'order[id]': 'desc' })
        });
      },
      // 确认授权
      onSubmit() {
        console.log(1)
      },
      // 导出excel
      excelExport() {

      },
      // 上课统计详情
      StatisticalClass(row) {
        localStorage.setItem('liveroom_action', JSON.stringify(row));
        if (this.id) {
          this.$router.push(`/account/bill/statisticalclass/${row.id}`)
        } else {
          this.$router.push(`/bill/statistical/class/${row.id}`)

        }
      }
    }
  }
</script>

<style scoped lang="scss">
.statistical {
  .total {
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    font-size: 16px;
    color: var(--color-primary);
    border-radius: 5px;
    box-sizing: border-box;
    padding: 10px;
    text-align: center;
    margin-bottom: 20px;
    background: #fff7e8;
    p {
      flex: 0 0 25%;
      margin: 20px 0;
      b {
        margin: 0 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Bill/Statistical.vue